module.exports = __webpack_public_path__ + "img/LATIN10_03.87d2433b.jpg";